// extracted by mini-css-extract-plugin
export default {"left":"muiIcons_left__D1UtN","right":"muiIcons_right__AAqED"};